module.exports = __webpack_public_path__ + "static/media/36.c5055cfb.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/accessoires/36.png
// module id = 404
// module chunks = 0